

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _integration = require('js/lib/integration');

require('./stateChangeListener');

var _miniBrowser = require('js/lib/miniBrowser');

require('components/xo-models/src/checkout/index');

require('components/xo-models/src/auth/lib/xoAPayUtils');

require('components/xo-models/src/app/index');

require('components/xo-login-components/src/login/fn');

require('components/xo-device-info/dist/index');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module().factory('$Middleware', function ($rootScope, $q, $util, $CheckoutAppDataModel, $CheckoutPayeeModel, $CheckoutCartModel, $DeviceInfo, $config, $meta, $FallbackError, $locale, $promise, $populate, $window, $timeout, $experiment, $TransactionEligibilityModel, $AuthModel, $dispatch, $logger, $pxp, $Class, $Api, $fn, $feature, $xoAPayUtils, $cookies) {
    return [function angularDebug() {

        window.root = $rootScope;
        window.injector = _angular2['default'].element(document.body).injector();

        /**
         * Config experiment to overwrite the $apply method and use $eval instead of $apply if it would throw a digest inprog error.
         * This is mainly to address a Firefox bug with angular digest and timeouts, where timeouts can interrupt normal execution flow under certain circumstances
         * Bug described here: https://github.com/angular/angular.js/issues/10083
         *
         * Can remove as a config option if this is a stable change
         */
        if ($config.safeApply) {
            $logger.info('overwriting_angular_apply');
            var proto = Object.getPrototypeOf && Object.getPrototypeOf($rootScope);

            if (!proto) {
                $logger.warn('overwriting_angular_apply_failed', {
                    reason: 'failed_to_get_prototype'
                });
            } else {
                var originalApply = proto.$apply;
                // If this gets used so many times, something is probably wrong so use original apply instead
                var skipAttempts = 10;

                proto.$apply = function (fn) {
                    if (skipAttempts && ($rootScope.$$phase === '$digest' || $rootScope.$$phase === '$apply')) {
                        skipAttempts--;

                        $logger.warn('inprog_error_skipped', {
                            stack: new Error().stack
                        });

                        this.$eval(fn);
                    } else {
                        originalApply.call(this, fn);
                    }
                };
            }
        }
    }, function waitForToken() {
        if ($util.isIFrame() && !$util.param('token') && !$meta.token) {
            return $q(function (resolve, reject) {
                $logger.info('await_token');

                window.addEventListener('message', function (event) {

                    var message = JSON.parse(event.data);

                    if (message.operation !== 'pass_token') {
                        return;
                    }

                    var token = message.token;

                    $logger.info('passed_token', {
                        token: token
                    });

                    $meta.token = token;

                    var $preloadApi = new $Api({
                        uri: 'preload'
                    });

                    $preloadApi.retrieve({
                        params: {
                            token: token
                        }
                    }).then(function (response) {

                        $preloadApi.setTransientCache(response.data);
                        resolve();
                    })['catch'](reject);
                }, false);
            });
        }
    }, function checkToken() {

        var pattern = /^EC-[0-9A-Z]{17}$/;
        var beamPattern = /^BA-[0-9A-Z]{17}$/;

        // wps token are not preceeded with 'EC-'
        var wpsPattern = /^[0-9A-Z]{17}$/;

        var urlToken = ($util.param('token') || '').trim().slice(0, 20);
        var bodyToken = ($meta.token || '').trim().slice(0, 20);

        if (urlToken && bodyToken && urlToken !== bodyToken) {
            $logger.error('token_mismatch', {
                server: bodyToken,
                client: urlToken
            });
        }

        if (pattern.test(urlToken)) {
            $rootScope.token = urlToken;
        } else if (pattern.test(bodyToken)) {
            $rootScope.token = bodyToken;
        } else if (wpsPattern.test(urlToken)) {
            $logger.info('isWpsPattern');
            $rootScope.token = urlToken;
        } else if (wpsPattern.test(bodyToken)) {
            $logger.info('isWpsPattern');
            $rootScope.token = bodyToken;
        } else if (beamPattern.test(urlToken)) {
            $rootScope.token = urlToken;
            $logger.info('cart_exchange_failed', {
                token: $rootScope.token
            });
        } else if (beamPattern.test(bodyToken)) {
            $rootScope.token = bodyToken;
            $logger.info('cart_exchange_failed', {
                token: $rootScope.token
            });
        } else {
            return $q.reject(new $FallbackError({
                reason: 'no_token',
                product: 'error'
            }));
        }
    }, function resolveLocale() {

        var models = {};

        return $populate(models, {
            appData: $CheckoutAppDataModel.instance($rootScope.token),
            cart: $CheckoutCartModel.instance($rootScope.token)
        })['finally'](function () {
            return $locale.retrieve({
                params: {
                    ipCountry: $meta.ipcountry,
                    localeTestUrlParam: $util.param('locale.test'),
                    checkoutShippingCountry: models.cart.get('purchase.shipping_address.country_code'),
                    merchantCountry: models.appData.get('merchant.merchant_country'),
                    checkoutSessionLocale: models.appData.get('merchant.merchant_locale'),
                    countryParam: $util.param('country.x'),
                    localeParam: $util.param('locale.x')
                }
            });
        });
    }, function fraudentInit() {
        return $fn.init();
    }, function setupIntegration() {
        return _miniBrowser.$miniBrowser.init($rootScope.token);
    }, function tokenExchange() {

        if (!_integration.$integration.getConfig('ALLOW_ONETOUCH_TOKEN_EXCHANGE')) {
            return;
        }

        if ($rootScope.isPartnerIntegration || !$util.isIFrame()) {
            return;
        }

        var auth = $AuthModel.instance();

        return auth.retrieve().then(function () {

            if (auth.logged_in || auth.remembered || !auth.refresh_token) {
                return;
            }

            return auth.action('onetouch');
        });
    }, function xcomponent() {

        if (window.xchild) {
            window.paypalCheckout = window.xchild;
        }

        if (window.xprops && window.xprops.init) {

            return $promise.run(function () {
                return $CheckoutAppDataModel.instance($rootScope.token).retrieve();
            }).then(function (checkoutAppData) {

                return window.xprops.init({
                    paymentToken: $rootScope.token,
                    cancelUrl: checkoutAppData.urls.cancel_url
                });
            });
        }
    }, function xcomponentAuth() {
        if (window.xprops && window.xprops.onAuth) {

            var auth = $AuthModel.instance();

            return auth.retrieve().then(function () {

                if (auth.access_token && (auth.logged_in || auth.remembered)) {
                    return window.xprops.onAuth({
                        accessToken: auth.access_token
                    });
                }
            });
        }
    }, function logPage() {

        $logger.info('href', {
            href: window.location.href,
            windowName: $window.name && $window.name.slice(0, 100)
        });

        var match = document.cookie.toString().match(/ectoken=([^;]+)/);

        if (match && match[1] === $rootScope.token) {
            $logger.info('returning_user_same_token');
        } else if (match && match[1] !== $rootScope.token) {
            $logger.info('returning_user_diff_token');
        } else {
            $logger.info('non_returning_user');
        }

        document.cookie = 'ectoken=' + $rootScope.token + '; expires=Fri, 31 Dec 9999 23:59:59 GMT;';

        if (window.performance && window.performance.navigation && _angular2['default'].isDefined(window.performance.navigation.type)) {

            var navigationType = {
                0: 'regular',
                1: 'reload',
                2: 'back_forward'
            }[window.performance.navigation.type];

            if (navigationType) {
                $logger.info('navigation_' + navigationType);
            }
        }
    }, function handleTagManager() {
        // The following section is added for AB testing
        return $pxp('xo_hermesnode_ec_tag_manager', {
            'ctx.COUNTRY': $locale.country
        }, '(xo_hermesnode_ec_tag_manager_)(.*)').then(function (result) {
            if (result) {
                if (result.treatment_name === 'xo_hermesnode_ec_tag_manager_treatment') {

                    // ****** Tag Manager Code Start Here ***********
                    window.dataLayer = {
                        // Two letter country code of the current page's content
                        contentCountry: $locale.country.toLowerCase(),
                        // Two letter locale
                        contentLanguage: $locale.lang.toLowerCase()
                    };

                    var tagManagerUrl = $config.urls.tagProdUrl;

                    // Based on the environment, Tag Manager end point can be changed.
                    // For now the local and stage end points are same.
                    if ($config.deploy.isLocal() || $config.deploy.isStage()) {
                        tagManagerUrl = $config.urls.tagStageUrl;
                    }

                    // Load bootstrap.js asynchronously
                    (function (i, s, o, g, r, a, m) {
                        i['tagManagerObject'] = r;
                        i[r] = i[r] || function () {
                            (i[r].q = i[r].q || []).push(arguments);
                        };
                        i[r].l = 1 * new Date();
                        a = s.createElement(o);
                        m = s.getElementsByTagName(o)[0];
                        a.async = 1;
                        a.src = g;
                        m.parentNode.insertBefore(a, m);
                    })(window, document, 'script', tagManagerUrl, 'tagManager');
                }
            }
        });
    }, function logoutGuest() {
        return $AuthModel.instance().retrieve().then(function (auth) {
            if (auth.guest) {
                $logger.info('guest_logout');

                return auth.action('logout');
            }
        });
    }, function checkGCEFallback() {

        var appData = $CheckoutAppDataModel.instance($rootScope.token);
        var cart = $CheckoutCartModel.instance($rootScope.token);
        var merchantCountry = appData.get('merchant.merchant_country');
        var throttle = $feature('redirectToCape', false, merchantCountry);
        var capeRedirect = throttle ? $experiment('cape_redirect_exp', throttle, $rootScope.token, {}) : false;

        return appData.retrieve().then(function () {
            return cart.retrieve().then(function () {
                if ((cart.payment_action === 'order' || cart.payment_action === 'sale') && appData.user_selected_funding_source_type === 'BML' && !capeRedirect) {
                    return $q.reject(new $FallbackError({
                        reason: 'gce_not_supported',
                        product: 'aries'
                    }));
                }
            });
        });
    }, function updatePaymentExperience() {
        $CheckoutAppDataModel.instance($rootScope.token).action('updatePaymentExperience', {
            data: {
                payment_experience: 'HERMESNODE',
                payment_experience_form_factor: _miniBrowser.$miniBrowser.isMiniBrowser() ? 'IN_CONTEXT' : 'FULL_PAGE'
            },
            silent: true,
            transientError: true
        });
    }, function checkProcessorDecline() {
        return $CheckoutAppDataModel.instance($rootScope.token).retrieve().then(function (appData) {

            if (appData.flags.processor_declined) {
                $logger.info('processor_decline_transaction');
                var authModel = $AuthModel.instance();

                if (authModel.auth_state === 'IDENTIFIED' && !$util.param('redirectToHermes')) {
                    // guest
                    return $dispatch('xoon', {
                        token: $rootScope.token,
                        hermesXoonRedirect: true
                    }, {
                        fromState: 'checkout_init',
                        toState: 'guest',
                        'locale.x': $locale.lang + '_' + $locale.country,
                        'country.x': $locale.country
                    });
                }

                return;
            }
        });
    }, function checkTransactionEligibility() {
        return $promise.hash({
            transactionEligibility: $TransactionEligibilityModel.instance($rootScope.token).retrieve(),
            isPartnerIntegration: _miniBrowser.$miniBrowser.getPartnerIntegration($rootScope.token),
            isDirectIntegration: _miniBrowser.$miniBrowser.getDirectIntegration($rootScope.token)
        }).then(function (data) {

            if (data.transactionEligibility.eligible && !data.transactionEligibility.lipp) {
                return $logger.info('transaction_eligible');
            }

            if (data.isPartnerIntegration) {
                return $logger.warn('partner_integration_ineligible_transaction');
            }

            if (!data.isDirectIntegration) {
                return $logger.warn('ineligible_indirect_transaction');
            }

            var appData = $CheckoutAppDataModel.instance($rootScope.token);

            if (appData.user_selected_funding_source_type === 'BML' && ($config.deploy.isLocal() || $config.deploy.isStage())) {
                return $logger.warn('ineligible_ppcbtn_transaction');
            }

            $logger.info('transaction_ineligible');

            return $q.reject(new $FallbackError({
                reason: 'transaction_ineligible',
                product: 'ux'
            }));
        });
    }, function checkAPayLogin() {
        // Check if browser supports PaymentRequest API.
        if (!$xoAPayUtils.isAPayAPISupported()) {
            return;
        }

        var models = {};

        return $populate(models, {
            payee: $CheckoutPayeeModel.instance($rootScope.token),
            auth: $AuthModel.instance(),
            cart: $CheckoutCartModel.instance($rootScope.token)
        }).then(function () {
            // Do nothing if user is already logged in.
            if (models.auth.logged_in || models.auth.remembered) {
                return;
            }

            // Do nothing for APay onboarding flow.
            if (models.cart.isWalletTokenization()) {
                return;
            }

            return $pxp('xo_hermes_apay', {
                'uid': models.payee.get('merchant.id', '')
            }, 'xo_hermes_apay_whitelist_treatment').then(function (t) {
                if (t && t.treatment_name === 'xo_hermes_apay_whitelist_treatment') {
                    // Check if apay is part of ui_experience cookie.
                    var ui_experience = $cookies && $cookies.ui_experience;
                    var params = $util.params(ui_experience);

                    if (!params || params.apay !== 'true') {
                        // Cookie is not set.
                        // For OneTouch, do nothing.
                        if (models.auth.refresh_token) {
                            return;
                        }

                        // Call PaymentRequest API to get JWT anyway
                        return $xoAPayUtils.authenticateAPay().then(function (result) {
                            // Set APay cookie for success case.
                            if (result) {
                                $xoAPayUtils.setAPayCookie($rootScope.token);
                            }
                            return;
                        });
                    }

                    if (models.auth.refresh_token) {
                        // Do nothing if OT user has seen APay login.
                        if (params && params.otapay === 'true') {
                            return;
                        }

                        return $pxp('xo_hermes_apay_ot_auth', {
                            'ctx.APAY': 'true'
                        }, 'xo_hermes_apay_ot_auth_(treatment|control)').then(function (tr) {
                            if (tr && tr.treatment_name === 'xo_hermes_apay_ot_auth_treatment') {
                                return $xoAPayUtils.authenticateAPay().then(function (result) {
                                    // Clear APay cookie for error case.
                                    if (!result) {
                                        $xoAPayUtils.clearAPayCookie($rootScope.token);
                                        return;
                                    }

                                    // Set OneTouch APay cookie.
                                    $xoAPayUtils.setOTAPayCookie($rootScope.token);
                                    return;
                                });
                            }
                            return;
                        });
                    } else {
                        return $pxp('xo_hermes_apay_auth', {
                            'ctx.APAY': 'true'
                        }, 'xo_hermes_apay_auth_(treatment|control)').then(function (tr) {
                            if (tr && tr.treatment_name === 'xo_hermes_apay_auth_treatment') {
                                return $xoAPayUtils.authenticateAPay().then(function (result) {
                                    // Clear APay cookie for error case.
                                    if (!result) {
                                        $xoAPayUtils.clearAPayCookie($rootScope.token);
                                    }
                                    return;
                                });
                            }
                            return;
                        });
                    }
                }
            });
        });
    }, function logStart() {
        return $promise.hash({
            isMiniBrowser: _miniBrowser.$miniBrowser.isMiniBrowser(),
            isDirectIntegration: _miniBrowser.$miniBrowser.getDirectIntegration($rootScope.token),
            isIframe: _miniBrowser.$miniBrowser.isFramed()
        }).then(function (flags) {
            var app_int_type = $DeviceInfo.getAppIntegrationType();
            $logger.info('app_start_design', {
                'from': 'client_middleware',
                'to': 'process_app_start_design',
                is_directintegration: flags.isDirectIntegration ? 1 : 0,
                is_incontext: flags.isMiniBrowser || flags.isIframe ? 1 : 0,
                app_int_type: app_int_type
            });
        });
    }, function logPerformance() {
        if (window.enablePerformance) {

            var keys = ['connectEnd', 'connectStart', 'domComplete', 'domContentLoadedEventEnd', 'domContentLoadedEventStart', 'domInteractive', 'domLoading', 'domainLookupEnd', 'domainLookupStart', 'fetchStart', 'loadEventEnd', 'loadEventStart', 'navigationStart', 'redirectEnd', 'redirectStart', 'requestStart', 'responseEnd', 'responseStart', 'secureConnectionStart', 'unloadEventEnd', 'unloadEventStart'];

            var timing = {};

            _angular2['default'].forEach(keys, function (key) {
                timing[key] = parseInt(window.performance.timing[key], 10) || 0;
            });

            var offset = timing.connectEnd - timing.navigationStart;

            if (timing.connectEnd && window.clientStartTime) {
                _angular2['default'].forEach(timing, function (time, name) {
                    if (time && _angular2['default'].isNumber(time)) {
                        $logger.info('timing_' + name, {
                            client_elapsed: time - timing.connectEnd - (window.clientStartTime - offset),
                            req_elapsed: time - timing.connectEnd
                        });
                    }
                });
            }

            $logger.info('timing', timing);

            if (window.performance.memory) {
                $logger.info('memory', window.performance.memory);
            }

            if (window.performance.navigation) {
                $logger.info('navigation', window.performance.navigation);
            }

            if (window.performance.getEntries) {
                var logged = [];

                var logResources = function logResources() {
                    _angular2['default'].forEach(window.performance.getEntries(), function (resource) {

                        if (!resource || !resource.name) {
                            return;
                        }

                        if (logged.indexOf(resource.name) === -1) {
                            logged.push(resource.name);
                        } else {
                            return;
                        }

                        if (resource.initiatorType) {
                            $logger.info(resource.initiatorType, resource);
                        }
                    });
                };

                logResources();
                setInterval(logResources, 500);
            }

            if (timing.connectEnd && timing.navigationStart && window.clientStartTime) {
                $logger.info('js_init', {
                    client_elapsed: 0,
                    req_elapsed: window.clientStartTime - offset
                });
            }
        } else {
            $logger.info('no_performance_data');
        }
    }, function logAuthState() {
        return $AuthModel.instance().retrieve().then(function (auth) {
            if (auth.logged_in) {
                $logger.info('user_logged_in');
            } else if (auth.remembered) {
                $logger.info('user_remembered');
            } else {
                $logger.info('user_not_logged_in');
            }
        });
    },

    // check for access token in the hash.
    function checkAccessToken() {
        var euat = $util.param('euat');

        if (euat) {
            var accessToken = euat === '1' ? window.location.hash.substr(2) : euat;

            if (accessToken) {
                $logger.info(euat === '1' ? 'access_token_from_hash' : 'access_token_from_param', {
                    access_token: accessToken
                });

                /* if (euat === '1') {
                    window.location.hash = '';
                } */

                var authModel = $AuthModel.instance();

                authModel.access_token = accessToken;
            }
        }
    },

    // check for FraudNet for Mobile View
    function enableFraudNetForMobileWebView() {
        if ($DeviceInfo.isApp()) {
            return $CheckoutAppDataModel.instance($rootScope.token).retrieve().then(function (appData) {
                return $pxp($config.ulMeta.hermesnodePxpConfig, {
                    'ctx.COUNTRY': appData.merchant.merchant_country
                }, 'xo_hermesnode_fraudnet_webview_treatment').then(function (result) {
                    if (result && result.treatment_name) {
                        $window.enableFraudNetForMobileWebView = true;
                    }
                });
            });
        }
    },

    // Logs if service workers are enabled
    function isServiceWorkerSupported() {
        if ('serviceWorker' in navigator) {
            $logger.info('service_worker_supported');
        } else {
            $logger.info('service_worker_not_supported');
        }
    }, function forceCookiesDisabled() {
        if ($DeviceInfo.isApp()) {
            return $CheckoutPayeeModel.instance($rootScope.token).retrieve().then(function (payee) {
                if (~$config.forceCookiesDisabled.indexOf(payee.merchant.id)) {
                    $logger.info('force_cookies_disabled');
                    $Api.forceCookiesDisabled = true;
                }
            });
        }
    }, function checkFramed() {
        if ($util.isIFrame()) {
            // Set this as "framed" mode (X icon, escape hatch, etc.)
            document.documentElement.className += ' framed';
        }
    }];
});

_integration.$integration;

_miniBrowser.$miniBrowser;


//////////////////
// WEBPACK FOOTER
// ./js/lib/middleware.js
// module id = ./js/lib/middleware.js
// module chunks = 1